import { useMutation, useQueryClient } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { RelationshipParams } from '../identityTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'
import { CONTACTS_QUERY_KEYS } from '@/hooks/useContacts'

export const useUnfavoriteUser = (params: RelationshipParams) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => identityServices.unfavoriteUser(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_FAVORITE_USERS],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_PROFILE, params.userId],
      })
      // Also invalidate the contacts favorites list
      queryClient.invalidateQueries({
        queryKey: [CONTACTS_QUERY_KEYS.favorites],
      })
    },
  })
}
